import axios from "axios";
import Config from "../Config.json";

export const getApiUrl = (path) => {
  return `${Config.API_BASE_URL}/api${path}`;
};

export const getHeaders = () => {
  const token = JSON.parse(localStorage.getItem("token"));

  if (!token) return {};

  return {
    Authorization: `Bearer ${token}`,
  };
};

export const apiPost = (path, data = {}) => {
  const url = getApiUrl(path);

  const options = {
    headers: getHeaders(),
  };

  const responseData = axios.post(url, data, options).catch(function (error) {
    throw error.response;
  });

  return responseData;
};

export const apiPut = (path, data = {}) => {
  const url = getApiUrl(path);
  const options = {
    headers: getHeaders(),
  };

  return axios.put(url, data, options);
};

export const apiGet = (path) => {
  const url = getApiUrl(path);

  const options = {
    headers: getHeaders(),
  };

  return axios.get(url, options);
};

export const apiDelete = (path, data = {}) => {
  const url = getApiUrl(path);

  const options = {
    headers: getHeaders(),
  };

  const responseData = axios.delete(url, data, options).catch(function (error) {
    throw error.response;
  });

  return responseData;
};
